import {
  Button,
  DrawerBody,
  DrawerFooter,
  Flex,
  FormControl,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { useCreateResellerModalContext } from '../ModalContext';

const ContractStep: React.FC = () => {
  const { nextStep, previousStep } = useCreateResellerModalContext();

  return (
    <>
      <DrawerBody>
        <Flex columnGap="5%" rowGap="1rem" wrap="wrap">
          <FormControl flexBasis="47.5%" isReadOnly>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Tipo de contrato
            </FormLabel>
            <Input value="Revendedor" bg="gray.50" />
          </FormControl>

          <FormControl flexBasis="47.5%" isReadOnly>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Periodicidade
            </FormLabel>
            <Input value="Mensal" bg="gray.50" />
          </FormControl>

          <FormControl flexBasis="47.5%" isReadOnly>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Forma de pagamento
            </FormLabel>
            <Input value="Boleto" bg="gray.50" />
          </FormControl>

          <FormControl flexBasis="47.5%" isReadOnly>
            <FormLabel fontSize="0.8rem" color="gray.500">
              Vencimento
            </FormLabel>
            <Input value="Todo dia 10" bg="gray.50" />
          </FormControl>
        </Flex>
      </DrawerBody>

      <DrawerFooter gap="1rem">
        <Button variant="outline" onClick={previousStep} flex="1">
          Voltar
        </Button>
        <Button colorScheme="yooga" onClick={nextStep} flex="1">
          Próximo
        </Button>
      </DrawerFooter>
    </>
  );
};

export default ContractStep;
